var _rect, _rect2, _text;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    role: "img",
    "aria-label": "Ashish Ranjan",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 92,
    height: 92,
    rx: 20,
    fill: "#2dd4bf"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 14,
    width: 18,
    height: 18,
    rx: 4,
    fill: "#0b1220"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 49,
    y: 70,
    textAnchor: "middle",
    fontFamily: "Helvetica Neue, Helvetica, Arial, sans-serif",
    fontWeight: 900,
    fontSize: 52,
    letterSpacing: -3,
    fill: "#0b1220"
  }, "AR")));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.8a6f92a3e62791dd71dac8e71f2b4e4f.svg";
export { ForwardRef as ReactComponent };